import {createActionWithPayload} from "../utils.actions";
import {KeyValue} from "../../reducers/auto-complete/autocomplete-authors.reducer";

export const [autoCompletePlanNodes, isAutoCompletePlanNodesAction] = createActionWithPayload<string>('SEARCH_AUTOCOMPLETE_PLAN_NODES');
export const [autoCompletePlanNodesSuccess, isAutoCompletePlanNodesSuccesAction] = createActionWithPayload<KeyValue[]>('SEARCH_AUTOCOMPLETE_PLAN_NODES_SUCCESS');
export const [autoCompletePlanNodesError, isAutoCompleteErrorPlanNodesAction] = createActionWithPayload<string>('SEARCH_AUTOCOMPLETE_PLAN_NODES_ERROR');
